<template>
  <div>
    <b-container >
      <b-row style="border=0px;">
        <b-col sm="2">
          <!-- <i class="h1 text-muted text-left mb-4 icon-pie-chart"></i> -->
          <i class="h1 fa-solid fa-weight-scale"></i>
        </b-col>
        <b-col sm="6">
          <div>
            <span class="h4 mb-0">{{
              this.realBRLocale.format(this.datasetsGraf)
            }}</span>
          </div>
          <div>
            <!-- <small class="text-muted text-uppercase font-weight-bold">
              pesados em
            </small> 
            <br>-->
            <small class="text-muted text-uppercase font-weight-bold">{{ this.quantidade }} pesagens</small>
          </div>
        </b-col>
        
      </b-row>
    </b-container>
  </div>
</template>


<script>
import { RotateSquare } from "vue-loading-spinner";

export default {
  data() {
    return {
      Cards: [],
      Link: true,
      realBRLocale: Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 3,
        maximumFractionDigits: 3,
      }),
    };
  },
  props: {
    datasetsGraf: {
      type: Number,
    },
    legendasGraf: {
      type: String,
    },
    quantidade: {
      type: Number,
    },
  },
  methods: {
  },
  components: {
    RotateSquare,
  },
};
</script>

<style lang="scss" scoped>
</style>
